import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Styled } from "./styles";
import { withErrorBoundary } from "@/components/hoc";
import { Params } from "@/types/utils";
import { BrandForm } from "@/components/brands";
import { isDefined } from "@/utils/validations";
import { Button, Typography } from "@mui/material";
import { getRoutes } from "@/utils/helpers";
import useQueryBrands from "@/hooks/queries/useQueryBrands";
import useQuerySubscription from "@/hooks/queries/useQuerySubscription";

const Brand: React.FC = () => {
    const { bid } = useParams<Params>();
    const { data } = useQueryBrands();

    const { data: subscription } = useQuerySubscription();

    const navigate = useNavigate();
    const routes = getRoutes();

    const brand = bid && data ? data.find(i => i._id === bid) : undefined;

    if (!subscription) return <Styled.Container />;

    const usage = subscription.usage;
    if (!bid && isDefined(usage.brands.available) && usage.brands.available === 0) {
        return (
            <Styled.Container>
                <Typography>
                    You've used up all available brand(s) for your current {subscription.plan} plan.
                </Typography>
                <Button onClick={() => navigate(routes.organizationSettings())}>Upgrade</Button>
            </Styled.Container>
        );
    }

    return (
        <Styled.Container>
            <BrandForm brand={brand} />
        </Styled.Container>
    );
};

export default withErrorBoundary({ component: "Brand" })(Brand);
